module.exports = __webpack_public_path__ + "img/downloadIcon.a3ecdf9d.svg";